var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "600px" },
      model: {
        value: _vm.labelChangeDialog,
        callback: function ($$v) {
          _vm.labelChangeDialog = $$v
        },
        expression: "labelChangeDialog",
      },
    },
    [
      _c("customDialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(" " + _vm._s(_vm.t("askSelectLabel")) + " "),
                _c(
                  "button",
                  {
                    attrs: { id: "dialog_exit" },
                    on: {
                      click: function ($event) {
                        _vm.labelChangeDialog = false
                      },
                    },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/popup_close.png"),
                        id: "btn_img",
                      },
                    }),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-row",
                  { staticClass: "ma-0 pa-0", attrs: { justify: "center" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "ma-0 pa-0", attrs: { cols: "10" } },
                      [
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 pt-7 pb-10 dialog_text",
                            attrs: { align: "center" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "12" },
                              },
                              [
                                _c("v-select", {
                                  staticClass: "ma-0 pa-0",
                                  attrs: {
                                    items: _vm.labelList,
                                    dense: "",
                                    "hide-details": "",
                                    outlined: "",
                                    placeholder: "選択してください",
                                    dark: "",
                                    "item-text": "labelName",
                                    "item-value": "id",
                                  },
                                  model: {
                                    value: _vm.selectedLabelId,
                                    callback: function ($$v) {
                                      _vm.selectedLabelId = $$v
                                    },
                                    expression: "selectedLabelId",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 pb-2",
                            attrs: { align: "center", justify: "center" },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: {
                                  id: "grey_btn",
                                  width: "8rem",
                                  height: "2rem",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.labelChangeDialog = false
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.t("cancel")))]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-0 ml-2",
                                attrs: {
                                  id: "blue_btn",
                                  width: "8rem",
                                  height: "2rem",
                                  loading: _vm.loading,
                                },
                                on: { click: _vm.confirm },
                              },
                              [_vm._v(_vm._s(_vm.t("change")))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }